/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// Used to display brand names on Order History and Order Detail Pages
const brandNames = {
    1001: '1-800-Flowers',
    1009: '1-800-Baskets',
    1010: 'Fruit Bouquets',
    1029: 'Shari\'s Berries',
    1025: 'Simply Chocolate',
    1002: 'The Popcorn Factory',
    1019: 'Harry & David',
    1020: 'Wolferman\'s',
    1027: 'The Market',
    1018: 'Stockyards',
    1012: 'Cheryl\'s Cookies',
    1034: 'Florists',
};

export default brandNames;
